<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ticketManagementIndex',
})
</script>
<template>
  <router-view v-if="$route.name !== 'ticket'" />
  <div v-else>
    <a-card>
      <div class="ticket-search">
        <a-form :model="state.tableData.param" class="global-search-form">
          <a-row :gutter="24">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="展览名称">
                <a-input v-model:value="state.tableData.param.exhibitionName" placeholder="请输入展览名称" :maxlength="50"
                  allow-clear />
              </a-form-item>
            </a-col>
            <!-- 原时间范围查询控件，逻辑保留但隐藏 -->
            <!-- <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8" class="mb-[10px]">
              <a-form-item label="展览日期">
                <a-range-picker v-model:value="state.dateRange" value-format="YYYY-MM-DD"
                  :placeholder="['开始日期', '结束日期']" style="width: 100%" :disabled-date="disabledDate"
                  :allow-empty="[true, true]" @calendar-change="onCalendarChange" @change="onDateChange"
                  @openChange="onOpenChange" />
              </a-form-item>
            </a-col> -->
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="展览日期">
                <ant-date-picker v-model:value="state.singleDate" value-format="YYYY-MM-DD" placeholder="请选择展览日期"
                  style="width: 100%" allow-clear @change="onSingleDateChange" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="4" class="mb-[10px]">
              <div class="card-col-action btn-group">
                <ant-button class="search mr-[10px]!" @click="getTableData" type="primary">
                  <SearchOutlined />查询
                </ant-button>
                <ant-button class="resetFun" @click="resetFun" type="primary">
                  <RedoOutlined />重置
                </ant-button>
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8" class="mb-[10px]">
              <div class="card-col-action flex justify-start md:justify-end">
                <ant-button class="add" @click="onAdd" type="primary" v-auth="'ticket.add'">
                  <PlusOutlined />新增门票
                </ant-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <ant-table :columns="columns" :data-source="state.tableData.data" :loading="state.tableData.loading"
        :pagination="false" row-key="ticketId">
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.key === 'index'">
            {{ (state.tableData.param.pageNum - 1) * state.tableData.param.pageSize + index + 1 }}
          </template>
          <template v-if="column.key === 'dateRange'">
            {{ record.startDate }} 至 {{ record.endDate }}
          </template>
          <template v-if="column.key === 'status'">
            <span class="ticket-status">{{ record.displayStatusName || getStatusText(record.displayStatus) }}</span>
          </template>
          <template v-if="column.key === 'action'">
            <div class="table-action-left">
              <a-button type="link" size="small" @click="onEdit(record)" v-auth="'ticket.edit'">编辑门票信息</a-button>
              <a-button type="link" size="small" @click="onConfigSession(record)"
                v-auth="'ticket.configuration'">配置场次</a-button>
              <a-button type="link" size="small" danger @click="onDelete(record)" v-auth="'ticket.del'">删除</a-button>
            </div>
          </template>
        </template>
      </ant-table>
      <ant-pagination v-model:current="state.tableData.param.pageNum" v-model:page-size="state.tableData.param.pageSize"
        :total="state.tableData.total" :page-size-options="['10', '20']" show-size-changer
        :show-total="(total) => `共 ${total} 条`" :showQuickJumper="true" @change="onPageChange"
        @show-size-change="onShowSizeChange" />
    </a-card>
  </div>
</template>

<script setup lang="ts" name="ticketManagementIndex">
import { reactive, onMounted, h, watch, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message, Modal } from 'ant-design-vue'
import { SearchOutlined, PlusOutlined, RedoOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { useTicket } from '@/store/ticket/ticket'
import { fetchWithPaginationFallback } from '@/utils/paginationFallback'
import dayjs from 'dayjs'

const router = useRouter()
const route = useRoute()
const ticketStore = useTicket()

const columns = [
  { title: '序号', key: 'index', width: 70 , align: 'center'},
  { title: '展览名称', dataIndex: 'exhibitionName', key: 'exhibitionName', ellipsis: true , align: 'center'},
  { title: '展览日期', key: 'dateRange', ellipsis: true , align: 'center'},
  { title: '状态', dataIndex: 'displayStatus', key: 'status', width: 100 , align: 'center'},
  { title: '更新时间', dataIndex: 'modifyTime', key: 'modifyTime', width: 180 , align: 'center'},
  { title: '操作', key: 'action', width: 240 , align: 'center'}
]

const state = reactive({
  singleDate: '',
  dateRange: [] as (string | null)[],
  tableData: {
    data: [] as any[],
    total: 0,
    loading: false,
    param: {
      pageNum: 1,
      pageSize: 10,
      exhibitionName: '',
      startDate: '',
      endDate: ''
    }
  }
})
const dates = ref<any[]>([])

const onSingleDateChange = (val: string | null) => {
  state.singleDate = val || ''
  // 同步到原范围参数，后端按开始日期或结束日期等于该日期查询
  state.tableData.param.startDate = state.singleDate
  state.tableData.param.endDate = state.singleDate
}

const onCalendarChange = (val: any[]) => {
  const newStart = val?.[0]
  const newEnd = val?.[1]

  if (!newStart && !newEnd) {
    dates.value = []
    return
  }

  if (dates.value.length === 2 && dates.value[0] && dates.value[1]) {
    const oldStart = String(dates.value[0])
    const oldEnd = String(dates.value[1])

    if ((!newStart || newStart === oldStart) && (!newEnd || newEnd === oldEnd)) {
      dates.value = [oldStart, oldEnd]
      return
    }

    const isStartChanged = !!(newStart && newStart !== oldStart)
    const isEndChanged = !!(newEnd && newEnd !== oldEnd)

    if (isStartChanged && !isEndChanged) {
      handleStartChange(newStart, oldEnd)
      return
    }

    if (!isStartChanged && isEndChanged) {
      handleEndChange(oldStart, newEnd)
      return
    }

    if (isStartChanged && isEndChanged) {
      const diffToStart = Math.abs(dayjs(newStart).diff(oldStart, 'days'))
      const diffToEnd = Math.abs(dayjs(newEnd).diff(oldEnd, 'days'))
      if (diffToStart <= diffToEnd) {
        handleStartChange(newStart, oldEnd)
      } else {
        handleEndChange(oldStart, newEnd)
      }
    }
    return
  }

  if (newStart && !newEnd) {
    dates.value = [newStart, undefined]
  } else if (!newStart && newEnd) {
    dates.value = [undefined, newEnd]
  } else if (newStart && newEnd) {
    dates.value = [newStart, newEnd]
  }
}

const handleStartChange = (newStart: string, oldEnd: string) => {
  const startDate = dayjs(newStart)
  const endDate = dayjs(oldEnd)
  const diffDays = endDate.diff(startDate, 'days')
  dates.value = [newStart, undefined]
  if (diffDays >= 0 && diffDays <= 365) {
    state.dateRange = [newStart, oldEnd]
  } else {
    state.dateRange = [newStart, null]
  }
}

const handleEndChange = (oldStart: string, newEnd: string) => {
  const startDate = dayjs(oldStart)
  const endDate = dayjs(newEnd)
  const diffDays = endDate.diff(startDate, 'days')
  dates.value = [undefined, newEnd]
  if (diffDays >= 0 && diffDays <= 365) {
    state.dateRange = [oldStart, newEnd]
  } else {
    state.dateRange = [null, newEnd]
  }
}

const onOpenChange = (open: boolean) => {
  if (open) {
    const [start, end] = state.dateRange
    if (start && end) {
      dates.value = [start, end]
    } else if (start) {
      dates.value = [start, undefined]
    } else if (end) {
      dates.value = [undefined, end]
    } else {
      dates.value = []
    }
  } else {
    validateDateRange()
  }
}

const onDateChange = (val: (string | null)[]) => {
  if (val && val.length === 2) {
    const [startStr, endStr] = val
    if (startStr && endStr) {
      const start = dayjs(startStr)
      const end = dayjs(endStr)
      const diffDays = end.diff(start, 'days')
      if (diffDays < 0 || diffDays > 365) {
        if (dates.value[0] && !dates.value[1]) {
          state.dateRange = [startStr, null]
          dates.value = [startStr, undefined]
        } else if (!dates.value[0] && dates.value[1]) {
          state.dateRange = [null, endStr]
          dates.value = [undefined, endStr]
        } else {
          state.dateRange = []
          dates.value = []
        }
        return
      }
      state.dateRange = [startStr, endStr]
      if (dates.value[0] && !dates.value[1]) {
        dates.value = [startStr, undefined]
      } else if (!dates.value[0] && dates.value[1]) {
        dates.value = [undefined, endStr]
      } else {
        dates.value = [startStr, endStr]
      }
    } else if (startStr) {
      state.dateRange = [startStr, null]
      dates.value = [startStr, undefined]
    } else if (endStr) {
      state.dateRange = [null, endStr]
      dates.value = [undefined, endStr]
    } else {
      state.dateRange = []
      dates.value = []
    }
  }
}

const validateDateRange = () => {
  if (state.dateRange.length === 2 && state.dateRange[0] && state.dateRange[1]) {
    const start = dayjs(state.dateRange[0])
    const end = dayjs(state.dateRange[1])
    const diffDays = end.diff(start, 'days')
    if (diffDays < 0 || diffDays > 365) {
      const [startStr, endStr] = state.dateRange
      if (dates.value[0] && !dates.value[1]) {
        state.dateRange = [startStr, null]
        dates.value = [startStr, undefined]
      } else if (!dates.value[0] && dates.value[1]) {
        state.dateRange = [null, endStr]
        dates.value = [undefined, endStr]
      } else {
        state.dateRange = []
        dates.value = []
      }
      return true
    }
  }
  return true
}

const disabledDate = (current: any) => {
  if (!dates.value || dates.value.length === 0) return false
  const currentDate = dayjs(current)

  if (dates.value.length === 2 && dates.value[0] && dates.value[1]) {
    return false
  }

  if (dates.value[0] && !dates.value[1]) {
    const start = dayjs(dates.value[0])
    const diffDays = currentDate.diff(start, 'days')
    return diffDays < 0 || diffDays > 365
  }

  if (!dates.value[0] && dates.value[1]) {
    const end = dayjs(dates.value[1])
    const diffDays = end.diff(currentDate, 'days')
    return diffDays < 0 || diffDays > 365
  }

  return false
}

const resetFun = () => {
  state.singleDate = ''
  state.dateRange = []
  dates.value = []
  state.tableData.param.exhibitionName = ''
  state.tableData.param.startDate = ''
  state.tableData.param.endDate = ''
  state.tableData.param.pageNum = 1
  getTableData()
}

const getStatusColor = (status?: number) => {
  switch (status) {
    case 0: return 'default'
    case 1: return 'success'
    case 2: return 'processing'
    case 3: return 'error'
    default: return 'default'
  }
}

const getStatusText = (status?: number) => {
  switch (status) {
    case 0: return '草稿'
    case 1: return '生效中'
    case 2: return '待生效'
    case 3: return '已失效'
    default: return '未知'
  }
}

const getTableData = async () => {
  validateDateRange()
  if (state.singleDate) {
    state.tableData.param.startDate = state.singleDate
    state.tableData.param.endDate = state.singleDate
  } else if (state.dateRange.length === 2 && state.dateRange[0] && state.dateRange[1]) {
    state.tableData.param.startDate = state.dateRange[0]
    state.tableData.param.endDate = state.dateRange[1]
  } else {
    state.tableData.param.startDate = ''
    state.tableData.param.endDate = ''
  }
  state.tableData.loading = true
  try {
    const data: any = await fetchWithPaginationFallback(
      (param) => ticketStore.getTicketPage(param),
      state.tableData.param
    )
    state.tableData.data = data.records || []
    state.tableData.total = data.total || 0
    state.tableData.param.pageNum = data.pageNum ?? state.tableData.param.pageNum
  } finally {
    state.tableData.loading = false
  }
}

const onAdd = () => {
  router.push('/ticket/add')
}

const onEdit = (record: any) => {
  router.push(`/ticket/edit/${record.id}`)
}

const onConfigSession = (record: any) => {
  router.push(`/ticket/session/${record.id}`)
}

const onDelete = (record: any) => {
  Modal.confirm({
    transitionName: '',
    title: '提示',
    icon: () => h(ExclamationCircleOutlined),
    centered: true,
    content: `此操作将永久删除展览："${record.exhibitionName}"，是否继续？`,
    okText: '确认',
    cancelText: '取消',
    onOk: () => {
      return ticketStore.deleteTicket(record.id).then(() => {
        message.success('删除成功')
        getTableData()
      })
    }
  })
}

const onPageChange = (page: number) => {
  state.tableData.param.pageNum = page
  getTableData()
}

const onShowSizeChange = (_current: number, size: number) => {
  state.tableData.param.pageSize = size
  state.tableData.param.pageNum = 1
  getTableData()
}

onMounted(() => {
  getTableData()
})

watch(
  () => route.name,
  (name) => {
    if (name === 'ticket') {
      getTableData()
    }
  }
)
</script>

<style scoped lang="less">
.btn-group {
  display: flex;
  white-space: nowrap;
}

.table-action-left {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.ticket-status {
  color: #5c5757;
}
</style>
